import SecureDownload from 'Pages/SecureDownload';
import Dashboard from "Pages/Dashboard";

export default [
    //{ path: '/', component: require('Pages/MainStage/Join').default },
    { path: '/', component: Dashboard },
    { path: '/secure-download/:id', component: SecureDownload },
];
